// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateTenantSecurityConfigurationMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateTenantSecurityConfigurationInput;
}>;


export type UpdateTenantSecurityConfigurationMutation = { __typename?: 'Mutation', updateTenantSecurityConfiguration?: { __typename?: 'TenantSecurityConfiguration', id: string, luminaryAccessControlEnabled?: boolean | null, luminarySupportAccess: Types.TenantSecurityConfigurationLuminarySupportAccess, luminarySupportAccessEndDate?: Time | null } | null };

export const Operations = {
  Mutation: {
    UpdateTenantSecurityConfiguration: 'UpdateTenantSecurityConfiguration' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const UpdateTenantSecurityConfigurationDocument = gql`
    mutation UpdateTenantSecurityConfiguration($input: AugmentedUpdateTenantSecurityConfigurationInput!) {
  updateTenantSecurityConfiguration(input: $input) {
    id
    luminaryAccessControlEnabled
    luminarySupportAccess
    luminarySupportAccessEndDate
  }
}
    `;
export type UpdateTenantSecurityConfigurationMutationFn = Apollo.MutationFunction<UpdateTenantSecurityConfigurationMutation, UpdateTenantSecurityConfigurationMutationVariables>;

/**
 * __useUpdateTenantSecurityConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateTenantSecurityConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantSecurityConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantSecurityConfigurationMutation, { data, loading, error }] = useUpdateTenantSecurityConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTenantSecurityConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantSecurityConfigurationMutation, UpdateTenantSecurityConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantSecurityConfigurationMutation, UpdateTenantSecurityConfigurationMutationVariables>(UpdateTenantSecurityConfigurationDocument, options);
      }
export type UpdateTenantSecurityConfigurationMutationHookResult = ReturnType<typeof useUpdateTenantSecurityConfigurationMutation>;
export type UpdateTenantSecurityConfigurationMutationResult = Apollo.MutationResult<UpdateTenantSecurityConfigurationMutation>;
export type UpdateTenantSecurityConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateTenantSecurityConfigurationMutation, UpdateTenantSecurityConfigurationMutationVariables>;